import { animate, style, transition, trigger } from '@angular/animations';

export class AnimationConstant {
  static FadeInOut = trigger('FadeInOut', [
    transition(':enter', [
      style({ opacity: 0, transform: 'translateY(50%)' }),
      animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
    ]),
    transition(':leave', [
      animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-50%)' })),
    ]),
  ]);
}
